import React from 'react';

const StaffMemberCard = ({ name, title, bio, picture }) => {
  return (
    <div className="flex items-center mb-8 bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 hover:-translate-y-1 transform">
      {/* Avatar */}
      <div className="flex-shrink-0 p-4">
        <img
          src={picture}
          alt={`${name}'s picture`}
          className="w-32 h-32 rounded-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="flex-1 p-4">
        <h2 className="text-2xl font-bold text-gray-900 mb-1">{name}</h2>
        <h3 className="text-lg text-gray-700 mb-2">{title}</h3>
        <p className="text-gray-600 text-sm leading-relaxed">{bio}</p>
      </div>
    </div>
  );
};

export default StaffMemberCard;
